import { render, staticRenderFns } from "./EncuestasProlipa.vue?vue&type=template&id=5819d4ac&scoped=true"
import script from "./EncuestasProlipa.vue?vue&type=script&lang=js"
export * from "./EncuestasProlipa.vue?vue&type=script&lang=js"
import style0 from "./EncuestasProlipa.vue?vue&type=style&index=0&id=5819d4ac&prod&scoped=true&lang=css"
import style1 from "./EncuestasProlipa.vue?vue&type=style&index=1&id=5819d4ac&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5819d4ac",
  null
  
)

export default component.exports